import { combineReducers } from 'redux';

import updateCEP from './update/reducer';

export default combineReducers({
  updateCEP,
});



// WEBPACK FOOTER //
// ./src/pages/updatecepcounts/state/reducer.js